var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationWebsite03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 178,
    viewBox: "0 0 220 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.717 34.4227L99.2572 47.6742L57.7304 22.6443C77.5279 22.5131 95.4473 24.3917 105.717 34.4227Z",
    fill: "#D6EAE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.5 0L112.978 19.5193C94.0477 25.507 76.1821 22.6801 58.8788 15.2195L122.5 0Z",
    fill: "#D6EAE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.984 19.5193L124.504 39.0327L105.717 34.4228L57.7304 22.6443C54.6202 20.7598 55.3499 16.0604 58.8847 15.2195L112.984 19.5193Z",
    fill: "#E7F2F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.713 96.1177C77.9585 117.748 67.8265 126.867 51.3186 130.803C49.1834 129.867 47.4369 128.077 46.6175 125.704L33.9016 88.7465C33.0882 86.373 33.3633 83.8861 34.4758 81.8405C53.2266 77.7434 70.4881 75.841 72.713 96.1177Z",
    fill: "url(#paint0_linear_471_6687)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.492 97.3463C130.305 99.7199 130.03 102.207 128.924 104.252C112.458 106.375 98.9582 103.024 90.6863 89.9751C93.7725 79.2463 102.009 67.456 112.081 55.2959C114.216 56.2322 115.962 58.0213 116.782 60.3949L129.498 97.3463H129.492Z",
    fill: "url(#paint1_linear_471_6687)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6803 89.9751L128.918 104.252C127.919 106.095 126.25 107.586 124.109 108.32L57.6167 131.071C55.4755 131.805 53.2385 131.65 51.3186 130.803L72.713 96.1237L77.4321 84.3095L90.6863 89.9751H90.6803Z",
    fill: "#91B3FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.081 55.2959L90.6863 89.9751L84.2387 100.424L72.7131 96.1177L34.4758 81.8405C35.4747 80.0037 37.1434 78.5128 39.2846 77.7792L105.783 55.0275C107.924 54.294 110.161 54.449 112.081 55.2959Z",
    fill: "url(#paint2_linear_471_6687)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7131 96.1177L70.4044 99.863L33.4351 85.8899C33.4471 84.4586 33.8119 83.0691 34.4758 81.8346L72.7131 96.1118V96.1177Z",
    fill: "#5D8CE3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0824 91.6211L86.6072 105.988L70.4044 99.863L72.7131 96.1237L84.2387 100.424L90.6863 89.9751L95.0824 91.6211Z",
    fill: "#5D8CE3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.081 55.2959C113.259 55.8088 114.318 56.59 115.167 57.58L95.0824 91.6151L90.6863 89.9691L112.081 55.2899V55.2959Z",
    fill: "#5D8CE3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M184.626 146.195C182.556 140.172 178.92 134.811 174.111 130.684C173.513 130.171 172.61 130.236 172.101 130.833C171.593 131.429 171.653 132.33 172.251 132.843C176.677 136.635 180.02 141.579 181.928 147.12L183.28 151.038C183.483 151.628 184.04 151.998 184.632 151.998C184.787 151.998 184.943 151.974 185.098 151.921C185.84 151.664 186.241 150.853 185.983 150.108L184.632 146.195H184.626Z",
    fill: "#00A183"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M162.759 124.076C155.115 121.344 146.67 121.285 138.966 123.915L135.694 125.036C134.947 125.292 134.552 126.103 134.809 126.849C135.012 127.439 135.569 127.809 136.161 127.809C136.316 127.809 136.472 127.785 136.621 127.732L139.893 126.61C147.082 124.153 154.654 124.201 161.79 126.759C162.531 127.022 163.351 126.64 163.62 125.901C163.883 125.161 163.5 124.344 162.759 124.076Z",
    fill: "#00A183"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M120.018 131.912C119.76 131.167 118.947 130.773 118.205 131.03L95.8839 138.663C95.1422 138.92 94.7415 139.731 94.9987 140.47C95.202 141.061 95.7583 141.43 96.3504 141.43C96.5059 141.43 96.6614 141.406 96.811 141.353L119.132 133.719C119.88 133.463 120.275 132.652 120.018 131.912Z",
    fill: "#00A183"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8437 144.49L59.752 151.02C57.9278 151.646 56.0377 152.058 54.1357 152.249C53.3522 152.326 52.778 153.024 52.8558 153.805C52.9335 154.539 53.5496 155.093 54.2793 155.093C54.3271 155.093 54.375 155.093 54.4168 155.081C56.5401 154.873 58.6455 154.413 60.6791 153.716L79.7708 147.179C80.5184 146.923 80.9132 146.118 80.656 145.372C80.3988 144.633 79.5854 144.233 78.8437 144.49Z",
    fill: "#00A183"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8781 151.109C37.9748 149.147 33.0583 145.11 30.0378 139.731C29.655 139.045 28.7818 138.8 28.094 139.182C27.4061 139.564 27.1609 140.434 27.5437 141.12C30.917 147.12 36.3957 151.628 42.975 153.811C43.1245 153.859 43.28 153.883 43.4295 153.883C44.0276 153.883 44.5839 153.507 44.7872 152.905C45.0325 152.159 44.6258 151.354 43.8781 151.103V151.109Z",
    fill: "#00A183"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M148.721 66.7224C148.464 65.9769 147.65 65.5833 146.909 65.8398L130.401 71.4874C129.659 71.7439 129.259 72.555 129.516 73.2945C129.719 73.8849 130.275 74.2546 130.867 74.2546C131.023 74.2546 131.178 74.2308 131.334 74.1771L147.836 68.5294C148.583 68.273 148.984 67.4619 148.721 66.7224Z",
    fill: "#00A183"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M179.787 52.97C180.271 52.3498 180.164 51.4553 179.542 50.9722C178.92 50.4891 178.022 50.5965 177.538 51.2167C174.637 54.9202 170.726 57.6874 166.246 59.2201L158.913 61.7248C158.171 61.9813 157.77 62.7923 158.028 63.5378C158.231 64.1282 158.787 64.498 159.379 64.498C159.535 64.498 159.69 64.4741 159.84 64.4204L167.173 61.9157C172.179 60.2041 176.539 57.1089 179.787 52.976V52.97Z",
    fill: "#00A183"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M169.96 14.802C175.349 17.7183 179.416 22.5132 181.408 28.298C182.287 30.8624 182.73 33.5163 182.73 36.194C182.73 37.1184 182.682 38.0368 182.574 38.9254C182.484 39.7066 183.047 40.4104 183.83 40.5058C183.884 40.5118 183.938 40.5177 183.998 40.5177C184.709 40.5177 185.331 39.981 185.415 39.2594C185.529 38.2634 185.589 37.2317 185.589 36.2C185.589 33.2062 185.092 30.2422 184.111 27.3796C181.886 20.9149 177.347 15.5594 171.318 12.3032C170.624 11.9275 169.763 12.184 169.386 12.8757C169.009 13.5675 169.266 14.4323 169.96 14.802Z",
    fill: "#00A183"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M128.493 20.6763L150.408 13.1799C152.956 12.3092 155.599 11.8619 158.255 11.8559C159.044 11.8559 159.684 11.2178 159.678 10.4246C159.678 9.64337 159.038 9.00525 158.249 9.00525C155.276 9.01121 152.328 9.5062 149.481 10.4783L127.566 17.9747C126.824 18.2312 126.423 19.0422 126.681 19.7817C126.884 20.3722 127.44 20.7419 128.032 20.7419C128.188 20.7419 128.343 20.7181 128.499 20.6644L128.493 20.6763Z",
    fill: "#00A183"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M116.22 158.594C114.563 153.781 114.868 148.694 117.075 144.257C117.422 143.553 117.135 142.701 116.429 142.349C115.723 141.997 114.868 142.289 114.515 142.993C111.967 148.11 111.614 153.978 113.516 159.518C114.527 162.452 116.094 165.071 118.181 167.313C118.463 167.617 118.845 167.766 119.222 167.766C119.569 167.766 119.922 167.641 120.197 167.385C120.771 166.848 120.807 165.947 120.269 165.375C118.457 163.425 117.093 161.146 116.214 158.594H116.22Z",
    fill: "#00A183"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M151.161 156.972C150.396 156.781 149.624 157.252 149.433 158.015C148.009 163.794 143.924 168.351 138.487 170.211C135.533 171.225 132.351 171.374 129.282 170.653C128.511 170.474 127.745 170.945 127.56 171.714C127.38 172.484 127.853 173.247 128.625 173.432C130.114 173.784 131.627 173.957 133.134 173.957C135.264 173.957 137.387 173.605 139.414 172.913C145.772 170.736 150.551 165.422 152.202 158.701C152.393 157.938 151.921 157.169 151.155 156.978L151.161 156.972Z",
    fill: "#00A183"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M130.03 133.528C130.054 134.316 130.718 134.936 131.501 134.906C137.656 134.715 143.607 137.989 147.034 143.44C147.304 143.869 147.77 144.108 148.249 144.108C148.506 144.108 148.769 144.036 149.008 143.893C149.678 143.476 149.881 142.599 149.463 141.931C145.503 135.628 138.589 131.847 131.424 132.067C130.634 132.091 130.018 132.747 130.042 133.534L130.03 133.528Z",
    fill: "#00A183"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3274 108.815C32.7473 108.284 31.8441 108.32 31.3058 108.904C26.497 114.14 23.9012 120.921 24.0029 128.006C24.0148 128.787 24.6488 129.407 25.4324 129.407H25.4563C26.2458 129.395 26.8738 128.751 26.8618 127.958C26.7662 121.607 29.0928 115.524 33.4171 110.83C33.9495 110.252 33.9136 109.351 33.3274 108.815Z",
    fill: "#00A183"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M194.925 176.115L189.261 159.65C189.004 158.91 188.19 158.51 187.443 158.767C186.701 159.023 186.3 159.834 186.558 160.58L192.222 177.04C192.425 177.63 192.981 178 193.573 178C193.729 178 193.884 177.976 194.04 177.922C194.782 177.666 195.182 176.855 194.925 176.115Z",
    fill: "#00A183"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_471_6687",
    x1: 33.4351,
    y1: 105.004,
    x2: 74.1066,
    y2: 105.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#D9E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#D9E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#D8E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#D8E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#D7E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D7E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D6E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D5E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D5E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D4E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D4E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D3E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D3E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D2E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D2E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D1E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#D0E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D0E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#CFE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#CFDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CDDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#CCDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CCDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#CBDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CBDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#CADCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CADCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C9DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C8DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C8DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C7DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C7DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#C6DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#C6D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C5D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C4D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C4D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#C3D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C2D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BFD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BFD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BED5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BED4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BDD4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BCD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#BCD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#BBD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#BAD2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#BAD2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#BAD2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#B9D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#B8D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B8D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B7D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B7D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B6CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_471_6687",
    x1: 90.6803,
    y1: 80.0693,
    x2: 129.964,
    y2: 80.0693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#D9E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#D9E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#D8E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#D8E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#D7E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D7E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D6E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D5E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D5E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D4E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D4E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D3E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D3E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D2E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D2E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D1E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#D0E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D0E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#CFE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#CFDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CDDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#CCDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CCDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#CBDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CBDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#CADCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CADCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C9DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C8DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C8DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C7DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C7DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#C6DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#C6D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C5D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C4D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C4D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#C3D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C2D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BFD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BFD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BED5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BED4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BDD4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BCD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#BCD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#BBD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#BAD2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#BAD2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#BAD2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#B9D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#B8D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B8D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B7D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B7D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B6CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_471_6687",
    x1: 34.4818,
    y1: 77.4929,
    x2: 112.081,
    y2: 77.4929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#D9E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#D9E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#D8E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#D8E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#D7E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D7E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D6E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D5E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D5E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D4E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D4E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D3E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D3E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D2E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D2E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D1E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#D0E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D0E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#CFE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#CFDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CDDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#CCDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CCDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#CBDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CBDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#CADCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CADCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C9DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C8DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C8DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C7DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C7DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#C6DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#C6D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C5D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C4D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C4D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#C3D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C2D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BFD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BFD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BED5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BED4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BDD4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BCD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#BCD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#BBD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#BAD2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#BAD2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#BAD2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#B9D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#B8D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B8D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B7D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B7D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B6CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6CFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationWebsite03);
export default __webpack_public_path__ + "static/media/illustration_website_03.74e6b077e6a9a64856f1da0ccaf0caf2.svg";
export { ForwardRef as ReactComponent };